import { useEffect, useRef, useState } from "react";
import { BasicButton } from "thrive-components";

function RequestMessage({message, onClick}: {message: string, onClick: ()=>void}) {
    const messageRef = useRef<HTMLSpanElement | null>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        const el = messageRef.current;
        if (!el) return;

        const isOverflowing = el.scrollWidth > el.clientWidth;
        setIsTruncated(isOverflowing);
    }, [message]);

    return (
        <span className="request-message-wrapper">
            <span
                ref={messageRef}
                className={`request-message`}
            >
                {message}
            </span>
            
            {isTruncated && (
                <BasicButton
                    onButtonClick={onClick}
                    ariaLabel={"Show full message"}
                    className='view-message-button'
                    content={"View"}
                />
            )}
        </span>
    );
}

export default RequestMessage;